import React, { useState, useEffect } from "react";
import "./index.css";
import BidTable from "../../components/Tables/bid_table";
import _ from "lodash";
import TripService from "../../services/TripService";

const DriverBidInfo = (props) => {
  const [visibleConformation, setVisibilityConformation] = useState(false);

  const [trips, setTrips] = useState([]);
  const [isedit, setIsedit] = useState(true);

  useEffect(() => {
    init().catch();
  }, [props?.driveinfo]);

  const init = async () => {
    const res = await TripService.getTrips({ driverId: props?.driveinfo?._id });
    setTrips((_.isArray(res?.data) && res?.data) || []);
  };

  const verifyVehicle = async () => {
    props?.handleModal(true);
    window.location.reload();
  };

  return (
    <BidTable
      trips={trips}
      isedit={isedit}
    />
  );
};
export default DriverBidInfo;
